/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector, useDispatch } from "react-redux";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import { FormattedMessage, injectIntl } from "react-intl";
import "../../../../_assets/sass/components/_profileDropdown.scss";
import ModalLayout from "../../modals/ModalLayout.tsx";
import AddToTeam from "../../../../../app/modules/Teams/components/Members/AddToTeam";
import { useAbac } from "react-abac";
import { Permission } from "../../../../../config/abac.config";
import { useFlags } from "../../../../../config/featureFlags";
import TeamEditModal from "../../../../../app/modules/Teams/components/team-edit-modal/TeamEditModal";
import {
  setCurrentTeamSuccess,
  teamsSelector,
} from "../../../../../app/modules/Teams/_redux/teamsSlice";

const UserProfileDropdown = ({ intl }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { currentTeam } = useSelector(teamsSelector);
  const { userHasPermissions } = useAbac();
  const features = useFlags();
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light:
          objectPath.get(uiService.config, "extras.user.dropdown.style") ===
          "light",
    };
  }, [uiService]);

  const [modalShow, setmodalShow] = useState(false);
  const [teamEditModalShow, setteamEditModalShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("teamId") == null) {
      localStorage.setItem("teamId", user.teams[0].id);
      setCurrentTeamAndTeamState(user.teams[0]);
    } else {
      findSelectedTeam();
    }
  }, []);

  async function setCurrentTeamAndTeamState(team) {
    await dispatch(setCurrentTeamSuccess(team));
  }

  const findSelectedTeam = () => {
    const team = user.teams.find((team) => {
      if (team.id === Number(localStorage.getItem("teamId"))) {
        return team;
      }
    });
    if (team === undefined) {
      localStorage.removeItem("teamId");
      window.location.reload();
    }
    setCurrentTeamAndTeamState(team);
  };

  const handleSwitchTeamClick = (e) => {
    localStorage.setItem("teamId", e.target.id);
    findSelectedTeam();
  };

  const addToTeam = (e) => {
    e.stopPropagation();
    setmodalShow(true);
  };

  const editTeam = (e) => {
    e.stopPropagation();
    setteamEditModalShow(true);
  };
  const ISGROUPADMIN = userHasPermissions(
      Permission.ADMINISTRATE_TEAM,
      currentTeam
  );

  return (
      <Dropdown drop="down" alignRight>
        <TeamEditModal
            show={teamEditModalShow}
            onHide={() => setteamEditModalShow(false)}
            team={currentTeam}
        />
        <ModalLayout
            title={intl.formatMessage({ id: "USER_PROFILE_DROPDOWN.TEAM.ADD" })}
            show={modalShow}
            onHide={() => setmodalShow(false)}
        >
          {{
            body: <AddToTeam teamId={currentTeam?.id} />,
          }}
        </ModalLayout>
        <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="dropdown-toggle-user-profile"
        >
          <div
              className={
                "btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2 user-dropdown-toggle"
              }
          >
          <span className="symbol symbol-35 symbol-light-success mr-4">
            <span className="symbol-label font-size-h5 font-weight-bold">
              {user.name[0]}
            </span>
          </span>
            <span className="d-none d-md-inline">
            <span className="font-weight-bolder font-size-base d-block text-left text-light">
              {user?.name}
            </span>
            <span className="font-weight-regular d-block text-left font-size-sm text-dark-25">
              {
                user?.email
                //currentTeam?.name
              }
            </span>
          </span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="p-0 m-0 dropdown-menu-left dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
          <div className="navi navi-spacer-x-0 p-5">
            <Dropdown drop="down" alignRight className="w-100">
              <Dropdown.Toggle
                  as={DropdownTopbarItemToggler}
                  id="dropdown-toggle-user-team"
              >
                <div className="btn w-100  d-flex align-items-center btn-lg px-2 user-dropdown-toggle">
                <span className="d-md-inline">
                </span>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="p-0 m-0 border-radius-top-0 w-100 dropdown-menu-left dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-sm">
                <div className="navi navi-spacer-x-0">

                </div>
              </Dropdown.Menu>
            </Dropdown>
            {features.DISPLAY_LIKUMI_CONTENT && ISGROUPADMIN && (
                <>
                  <button
                      className="btn btn-primary font-weight-regular d-block text-left font-size-sm text-dark-25 mt-3"
                      onClick={(e) => addToTeam(e)}
                  >
                    <FormattedMessage id="USER_PROFILE_DROPDOWN.TEAM.ADD" />
                  </button>
                  <button
                      className="btn btn-primary font-weight-regular d-block text-left font-size-sm text-dark-25 mt-3"
                      onClick={(e) => editTeam(e)}
                  >
                    <FormattedMessage id="TEAM.EDIT.FORM_TITLE" />
                  </button>
                </>
            )}

            <div className="navi-footer  px-8 py-5">
              <Link
                  to="/logout"
                  className="btn btn-light-primary font-weight-bold"
              >
                <FormattedMessage id="USER_PROFILE_DROPDOWN.SIGNOUT" />
              </Link>
              {/*
            <a href="#" className="btn btn-clean font-weight-bold">
              Upgrade Plan
            </a>
            */}
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
  );
};

export default injectIntl(UserProfileDropdown);
